
import { SET_IS_ARCHIVED_DSR } from '../../actions/dsr-actions-types';

const INITIAL_STATE_SET_IS_ARCHIVED_DSR = { results: '' }

export function setIsArchivedDsrReducer(state = INITIAL_STATE_SET_IS_ARCHIVED_DSR, action) {
    switch (action.type) {
        case SET_IS_ARCHIVED_DSR:
            return { results: action.payload }
        default:
            return state;
    }
}